import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class CreateRepeatableEventForm {
  public name: string = '';
  public description: string = '';
  public location: string = '';
  public author: string = '';
  public withAttendance: boolean = false;
  public attendanceLimit: number = 0;
  public date: string = '';
  public signUpEndDate: number;
  public repeatEvery: number = 0;
  public weeklyCustom: number[] = [];

  public rules: { [key: string]: FormValidationFunction[] } = {
    name: [
      (v: string) => !!v || 'Name field is required.',
    ],
    description: [
      (v: string) => !!v || 'This field is required.',
    ],
    location: [],
    author: [
      (v: string) => !!v || 'This field is required.',
    ],
    withAttendance: [],
    attendanceLimit: [
      (v: number) => !!v || 'This field is required.',
      (v: number) => !(v < 1) || 'The value must be greater than 0.',
    ],
    date: [
      (v: string) => !!v || 'Date field is required.',
    ],
    signUpEndDate: [
      (v: number) => !(v < 1 || v > 365) || 'The value must be between 1 and 365 days.',
    ],
    repeatEvery: [
      (v: number|null|undefined) =>
        v !== null && v !== undefined || 'This field is required.',
    ],
    weeklyCustom: [
      (v: number[]) => {
        if (this.repeatEvery === 2 && v.length < 1) {
          return 'This field requires at least one option selected.';
        }

        return true;
      },
    ],
  };
}
